import React, { FC } from 'react';
import Icon from '~ComponentsImproved/Icon';
import { Box } from '~Styles';
import Paragraph from '~ComponentsImproved/Typography/Paragraph';
import useI18n from '~Translations';
import NoReportSrc from '~Assets/icons/no-report.svg';

/**  UI component to show that there is no report for that date */
const NoReport: FC = () => {
  const { i18n } = useI18n();
  const isHandyBreakpoint = window.innerWidth <= 600;

  return (
    <Box
      style={{ height: '50vh' }}
      display="flex"
      alignItems="center"
      flexDirection="column"
      gap="small"
      justifyContent="center">
      <Icon
        width="48px"
        height="48px"
        src={NoReportSrc}
        color={isHandyBreakpoint ? 'var(--colorWhite)' : 'var(--colorBlueGray1300)'}
      />
      <Paragraph
        level={3}
        color={isHandyBreakpoint ? 'var(--colorWhite)' : 'var(--colorBlueGray1300)'}>
        {i18n('Report.NoReport')}
      </Paragraph>
    </Box>
  );
};

export default NoReport;
